export const QOXY_DOMAIN_HOSTING_NONE = 'none';

export const QOXY_DOMAIN_HOSTING_OPTIONS = Object.freeze([
  {
    value: QOXY_DOMAIN_HOSTING_NONE,
    label: 'None',
    productId: null,
    productTermId: null,
  },
  {
    value: 'email-4-years',
    label: 'Email Hosting for 3 Mailboxes x 5GB Each SGD2.95/month (4 Years)',
    productId: 247,
    productTermId: 8,
    couponCode: 'QC4Y',
  },
  {
    value: 'email-3-years',
    label: 'Email Hosting for 3 Mailboxes x 5GB Each SGD3.45/month (3 Years)',
    productId: 247,
    productTermId: 7,
    couponCode: 'QC3Y',
  },
  {
    value: 'email-2-years',
    label: 'Email Hosting for 3 Mailboxes x 5GB Each SGD3.95/month (2 Years)',
    productId: 247,
    productTermId: 6,
    couponCode: 'QC2Y',
  },
  {
    value: 'email-1-year',
    label: 'Email Hosting for 3 Mailboxes x 5GB Each SGD5.95/month (1 Year)',
    productId: 247,
    productTermId: 5,
    couponCode: null,
  },
  {
    value: 'web-4-years',
    label: 'Web Hosting 20GB Storage 1CPU 1GB Memory with Free 10 Email accounts SGD3.95/month (4 Years)',
    productId: 679,
    productTermId: 8,
    couponCode: 'QCH4Y',
  },
  {
    value: 'web-3-years',
    label: 'Web Hosting 20GB Storage 1CPU 1GB Memory with Free 10 Email accounts SGD4.95/month (3 Years)',
    productId: 679,
    productTermId: 7,
    couponCode: 'QCH3Y',
  },
  {
    value: 'web-2-years',
    label: 'Web Hosting 20GB Storage 1CPU 1GB Memory with Free 10 Email accounts SGD5.95/month (2 Years)',
    productId: 679,
    productTermId: 6,
    couponCode: 'QCH2Y',
  },
  {
    value: 'web-1-year',
    label: 'Web Hosting 20GB Storage 1CPU 1GB Memory with Free 10 Email accounts SGD9.95/month (1 Year)',
    productId: 679,
    productTermId: 5,
    couponCode: null,
  },
]);

export function shouldShowQoxyDomainHosting(brand, noCheckout) {
  return String(brand || '').toLowerCase() === 'qoxy' && noCheckout !== true;
}

export function getQoxyDomainHostingOption(selection) {
  return QOXY_DOMAIN_HOSTING_OPTIONS.find((option) => option.value === selection)
    || QOXY_DOMAIN_HOSTING_OPTIONS[0];
}

export function buildQoxyHostingCartRequest(selection, domain, domainRegistration) {
  const option = getQoxyDomainHostingOption(selection);

  if (!option.productId) {
    return null;
  }

  const request = {
    product_id: option.productId,
    product_term: option.productTermId,
    domain,
    module_data: { domain },
    domain_registration: domainRegistration,
  };

  if (domainRegistration.shopping_cart_id) {
    request.shopping_cart_id = domainRegistration.shopping_cart_id;
  }

  if (option.couponCode) {
    request.coupon_code = option.couponCode;
  }

  return request;
}
